import type { DeepRequired } from '../fixtures.types'

const documentVerification: DeepRequired<DocumentVerification> = {
  __typename: 'DocumentVerification',
  id: 'TEST_ID',
  verification_id: null,
  document_id: null,
  document: null,
  verification_date: null,
  verification_type: null,
  source: null,
  source_user: null,
  source_user_id: null,
  client: null,
  client_id: null,
  fingerprint: null,
  document_signature: null,
  signature_key_id: null,
  source_client: null,
  result: null,
  result_justification: [],
}

export default documentVerification
